import { render, staticRenderFns } from "./UploadCSV.vue?vue&type=template&id=227ef143&scoped=true&"
import script from "./UploadCSV.vue?vue&type=script&lang=js&"
export * from "./UploadCSV.vue?vue&type=script&lang=js&"
import style0 from "./UploadCSV.vue?vue&type=style&index=0&id=227ef143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ef143",
  null
  
)

export default component.exports